import axios from "axios";
import { getAppInstallationId, getSocketId } from "../helpers/authorizationHelpers";
import { io } from "socket.io-client";
// import config from "../../../data/static/config.json"

const url = window.location.hash.split('/');
const appInstallationId: string | undefined = url[2]

export const baseURL = window.location.host.includes("localhost") ? "http://localhost:9501" : "";
export const baseURI = `/installed/${appInstallationId ?? "null"}`;

const a = axios.create({
    baseURL: baseURL,
    validateStatus: () => true,
    headers: {
        appinstallationid: getAppInstallationId(),
        socketId: getSocketId(),
    }
});
a.interceptors.response.use(
    (response) => response,
    (error) => {
        console.warn("Axios error intercepted:", error.message);
        return Promise.resolve(); // Prevent errors from crashing your app
    }
);

export default a

export const socket = io(baseURL);